import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { StyledDropdownHeader } from './Dropdown.styles';
export const DropdownHeader = React.forwardRef(({ children, ...props }, ref) => (_jsx(StyledDropdownHeader, { ref: ref, role: 'heading', ...props, children: children })));
DropdownHeader.displayName = 'DropdownHeader';
export default DropdownHeader;
